var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0006 8.75L17.6929 16.1719C17.5616 16.3052 17.4953 16.372 17.4365 16.4245C16.4873 17.2741 15.052 17.2742 14.1028 16.4246C14.044 16.372 13.9772 16.3052 13.8458 16.1719C13.7145 16.0385 13.6488 15.9718 13.5901 15.9192C12.6409 15.0696 11.205 15.0696 10.2558 15.9192C10.1971 15.9717 10.1317 16.0382 10.001 16.1709L5 21.25M25.0006 8.75L25 16.25M25.0006 8.75H17.5",
    stroke: "#16A34A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUpIcon);
export default __webpack_public_path__ + "static/media/trendingUpIcon.ba19c9e4fa226e03bda453811ac67f84.svg";
export { ForwardRef as ReactComponent };